import type { IconColor, IconVariant } from '@components/reusable'
import {
  MolsonButton,
  MolsonDialog,
  MolsonDialogActions,
  MolsonDialogContent,
  MolsonDialogHeader
} from '@components/reusable'
import type { ReactNode } from 'react'

export type ConfirmationDialogProps = {
  title: string
  subtitle?: string
  primaryBtnText: string
  secondaryBtnText: string
  isOpen: boolean
  closeDialog: () => void
  content?: ReactNode
  confirmDialog: () => void
  size?: 'sm' | 'md' | 'lg'
  confirmationAction?: 'success' | 'delete'
  headerIcon?: IconVariant
  headerIconColor?: IconColor
  loading?: boolean
  forcefullyHideDividers?: boolean
}

export const ConfirmationDialog = ({
  title,
  subtitle,
  primaryBtnText,
  secondaryBtnText,
  isOpen,
  closeDialog,
  confirmDialog,
  content,
  size = 'sm',
  confirmationAction = 'success',
  headerIcon,
  headerIconColor,
  loading = false,
  forcefullyHideDividers = false
}: ConfirmationDialogProps) => {
  return (
    <MolsonDialog
      open={isOpen}
      onClose={closeDialog}
      maxWidth={size}
      fullWidth={true}
    >
      <MolsonDialogHeader
        title={title}
        subTitle={subtitle}
        headerIcon={headerIcon}
        iconColor={headerIconColor}
        displayDivider={!!content && !forcefullyHideDividers}
      />
      {content ? (
        <MolsonDialogContent sx={{ pb: forcefullyHideDividers ? 0 : 4 }}>
          {content}
        </MolsonDialogContent>
      ) : null}
      <MolsonDialogActions
        displayDivider={!!content && !forcefullyHideDividers}
      >
        <MolsonButton
          onClick={closeDialog}
          variant="outlined"
          color="secondary"
        >
          {secondaryBtnText}
        </MolsonButton>
        <MolsonButton
          onClick={confirmDialog}
          variant="contained"
          color={confirmationAction === 'success' ? 'primary' : 'error'}
          loading={loading}
        >
          {primaryBtnText}
        </MolsonButton>
      </MolsonDialogActions>
    </MolsonDialog>
  )
}
